<template>
    <el-aside style="padding-top:10px;" :class="{hinden_left:collapsed}">
        <div v-show="!collapsed">
            <div class="search-tit" v-show="select1">
                <!-- <h3 v-if="userType !=0 && differentiate == true">建筑列表</h3>
                <h3 v-if="userType !=0 && differentiate == true">校企列表</h3>
                <h3 v-if="userType !=0 && differentiate == false && floorType == 1">监测点列表</h3>
                <h3 v-if="userType !=0 && differentiate == false && floorType != 1 ">建筑列表</h3>
                <h3 v-if="userType !=0 && differentiate == false && floorType != 1 ">校企列表</h3> -->
                <h3 v-if="userType ==0 ">校企列表</h3>
                <h3 v-else>建筑列表</h3>
                <div @click="listsecher">
                    <i></i>
                </div>
            </div>
            <div class="search-btn" v-show="!select1" @mousemove="mousearch">
                <i @click="differentiate ? getBuilding() : getCheckPoint()"></i>
                <el-input
                  :placeholder="tipInput"
                  v-model="navListName"
                  @clear="clearableBack"
                  ref="inputRef"
                  @blur.native.capture="differentiate ? testMess() : searchMonter()"
                  @keyup.enter.native="differentiate ? getBuilding() : getCheckPoint()"
                  clearable>
                </el-input>
            </div>
            <gemini-scrollbar class="sidebar" :style="{'height': heightLeft + 'px'}" :autoshow="true">
                <div>
                    <div class="tree" v-show="select2">
                        <div class="chapter" v-for="(item, index) in navList" :key="index">
                            <div class="title">
                                <i v-if="userType !=0" :class="!item.active ? 'icon-bottom' : 'icon-up'" @click="handle(item.id)"></i>
                                <i v-if="userType ==0" class="groupIcon" @click="handle(item.id)"></i>
                                <!-- //showcus 客户是否可以点击1表示可以0不可以 -->
                                 <!-- differentiate//判断是否可以取消选中 -->
                                <div v-if="showcus" style="display:inline-block;width: calc(100% - 47px);" @click="differentiate ? handleOpen(item.id,item.label) : nothing(item.id)">
                                    <span v-if="differentiate" :class="{'menu_select':menuS == item.id}">{{item.label}}
                                        <em :class="{tip_detailForm:item.showRed&&isShowFirst}"></em>
                                    </span>
                                    <span :class="{'menu_select':menuS == item.id}"  v-else>{{item.label}}</span><div v-show="item.alarmTrue==1&& superviseTagging=='MonitoringSupervise'"  class="Divbadge"></div>
                                    <b v-show="navAddShow&&userType!=0" v-if="isAuth('basicData:insertBuildInfo')" @click.stop="editBuilding"></b>
                                </div>
                                <div v-else style="display:inline-block;width: calc(100% - 47px);height:auto;">
                                    <span>{{item.label}}
                                        <span v-for="(items,indexs) in item.children" :key="indexs">
                                            <em v-for="(todo,indext) in redArray" :key="indext" :class="{tip_detailForm:items.id == todo&&isShowFirst}"></em>
                                        </span>
                                    </span>
                                    <b v-show="navAddShow" @click.stop="editBuilding"></b>
                                </div>
                            </div>
                            <ul :class="!item.active ? 'show' : 'hide'">
                                <li class="section" @mouseover="userType!=0?enter(items.id):''" @mouseout="userType!=0?leave():''" v-for="(items,indexs) in item.children" :key="indexs" >
                                    <!-- differentiate//判断是否可以取消选中 -->
                                    <div style="width:100%;position: relative;">
                                      <div  class="section_text" :class="[{'menu_select': differentiate ? menuS == items.id : menuS2 == items.id},{'margin10':userType==0}]" :style="{width: spanWidth + 'px'}">
                                        <i v-if="item.size==3" :class="!items.activeT ? 'icon-bottom' : 'icon-up'" @click="handleChildren(items.id)"></i>
                                          <el-tooltip v-show="item.size==3"  effect="dark" :content="items.label" :disabled="spanWidth > overflowText" placement="bottom-start">
                                              <span  @click="differentiate ? getMap(item.id,item.label,items.id,items.label,'1','jian','middle') : getmapInfo(items,items.id,items.floorId,items.buildingId,items.floorIndex)"  @mouseover="changeText($event)">{{items.label}}&nbsp;<div v-show="items.alarmTrue==1&& superviseTagging=='MonitoringSupervise'"  class="Divbadge" value=" "></div>
                                                  <em v-for="(todo,indext) in redArray" :key="indext" :class="{tip_detailForm:items.id == todo&&isShowDot}"></em>
                                              </span>

                                          </el-tooltip>

                                          <el-tooltip v-show="item.size==2"  effect="dark" :content="items.label" :disabled="spanWidth > overflowText" placement="bottom-start">
                                              <span @click="differentiate ? getMap(item.id,item.label,items.id,items.label,'1','school','middle') : getmapInfo(items,items.id,items.floorId,items.buildingId,items.floorIndex)"  @mouseover="changeText($event)"><span @click="superviseTagging=='constructionManagement'&&userType!=0?checkEdit(item.id,item.label,items.id,items.label):''">{{items.label}}</span> &nbsp;<div v-show="items.alarmTrue==1&& superviseTagging=='MonitoringSupervise'"  class="Divbadge" value=" "></div>
                                                <em v-show="superviseTagging!='MonitoringSupervise'" v-for="(todo,indext) in redArray" :key="indext" :class="{tip_detailForm:items.id == todo&&isShowDot}"></em>
                                            </span>

                                          </el-tooltip>
  
                                      </div>
                                      <b v-show="navAddShow&&userType==0" class="editAdd" v-if="isAuth('basicData:insertBuildInfo')" @click.stop="editBuilding(items.id)"></b>

                                       <!-- 建筑管理校企端的楼层图标样式 -->
                                       <b v-show="navAddShow && editshow == items.id&&userType!=0" class="edit"  @click.stop="checkEdit(item.id,item.label,items.id,items.label)"></b>
                                    </div>

                                    <!-- differentiate//判断是否可以取消选中 -->
                                    <span v-if="items.remark == '0'"><b class="b tag" ref="FloorMark" v-show="!differentiate ? !items.flag : false"></b></span>
                                    <span v-else-if="items.remark == '1' && items.floorIndex != null"><b class="b" ref="FloorMark" v-show="!differentiate ? !items.flag : false">{{items.floorIndex > 0 ? 'L' + items.floorIndex : 'B' + Math.abs(items.floorIndex)}}</b></span>
                                    <!-- 安监云 -->
                                    <div v-else>
                                      <span v-if="userType != 0"><b class="b tag" ref="FloorMark" v-show="!differentiate ? items.already == true : false"></b></span>
                                      <span v-else><b class="b tag" ref="FloorMark" v-show="!differentiate ? (items.already == true && btnShow == 'false') : false"></b></span>
                                    </div>
                                    <div class="floorLeft"  :class="!items.activeT ? 'show' : 'hide'">
                                      <div  @mouseover="userType==0?enter(items1.id):''" @mouseout="userType==0?leave():''"  class="floorLeftChild" v-for="(items1,indexs1) in items.children" :key="indexs1">


                                        <div :class="[{'menu_select':menuS == items1.id},{'margin60':userType==0}]" class="floorLeftChildL"  :style="{width: spanWidthChild + 'px'}"   @click="superviseTagging=='constructionManagement'&&userType==0?checkEdit(items.id,items.label,items1.id,items1.label) : getMap(items.id,items.label,items1.id,items1.label,'1','school') " >
                                          {{items1.label}}
                                          <div v-show="items1.alarmTrue==1&& superviseTagging=='MonitoringSupervise'"  class="Divbadge"></div>
                                        
                                          
                                            <em v-show="superviseTagging=='searchWarnIndex'"   v-for="(todo,indext3) in redArray" :key="indext3+'sw'" :class="{tip_detailForm1:items1.id == todo&&isShowFirst}"></em>
                                            <em v-show="superviseTagging=='warningManger'||superviseTagging=='indexExamine'"  v-for="(todo,indext2) in redArray" :key="indext2+'sv'" :class="{tip_detailForm1:items1.id == todo&&isShowDot}"></em>
                                        </div>
                                        <b v-show="navAddShow && editshow == items1.id&&userType==0" class="edit" @click.stop="checkEdit(items.id,items.label,items1.id,items1.label)"></b>
                                      </div>
                                    </div>

                                </li>

                               
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="no-data" v-show="!select2">
                    <img src="../../static/img/Noresult.png">
                    <div style="color: #F5F5F5">查询结果为空</div>
                </div>
            </gemini-scrollbar>
        </div>
        <div class="menu-toggle" @click="leftoggle()">
            <i class="iconfont icon-outdent" v-show="!collapsed" title="收起"></i>
            <i class="iconfont icon-indent" v-show="collapsed" title="展开"></i>
        </div>
        <!-- 确认提示框 -->
        <el-dialog title="提示" class="tipsTwo" :visible.sync="dialogTipsSureVisible">
            <div>{{tipsTwo}}</div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogTipsSureVisible = false">取 消</el-button>
                <el-button type="primary" @click="TipsSure()">确 定</el-button>
            </div>
        </el-dialog>
    </el-aside>
</template>
<script>
    import {ajaxFuncJson} from '@/api/ajax';
    import {mapState,mapGetters,mapActions} from 'vuex'
    export default {
        props: ['itemActive'],
        data() {
            return {
                btnShow:sessionStorage.getItem('btnShow'),
                floorType:sessionStorage.getItem("floor"),
                userType:sessionStorage.getItem("userType"),
                handleUl: true,
                dialogTipsSureVisible:false, //确认提示
                tipsTwo:'本次编辑内容尚未保存，确定退出吗？', //确认提示语
                select1: true,  //搜索控制是否显示
                select2: true,  //查询是否有结果
                collapsed: false, //展开收起收起按钮
                navListName: '',
                differentiate: JSON.parse(sessionStorage.getItem('differentiate')),  // 判断时点击建筑还是监测点
                superviseTagging:sessionStorage.getItem('router'),
                floorid: '', // 默认第一层id
                floorListData: [],
                msg: '',
                tipInput:'搜校企名称',
                heightLeft: '', //计算左侧导航的高度
                menuS2: sessionStorage.getItem('menuS2'),
                menuS2Change:false,
                isShowLeftNav:false,
                openID: [],//第二集合节点
                openIDChildren: [],//第三集合节点
                editshow: '',
                showcus: sessionStorage.getItem('showcus') == 1 ? true : false,  // 客户是否可以点击1表示可以0不可以
                spanWidth: '',
                spanWidthChild:'',
                overflowText: '',
                redArray:[],
                target:'',
                redShow:false
            }
        },
        created() {
            this.redArray = this.$store.state.reddata;     
            if (this.redArray != null) {
                if(this.redArray.length != 0){
                    this.redShow = true;
                }
            };
            let openArray = JSON.parse(sessionStorage.getItem('openID'));  //监听左侧导航展开
            if (openArray != null) {
                this.$store.state.leftMonitorInfo.map( e => { 
                    openArray.map(i => {
                        if (i == e.id) {
                            e.active = false;
                        }
                    })
                })
            };

            if(sessionStorage.getItem('userType') == 0 ){
              sessionStorage.setItem('buildingId','123');  // 缓存建筑id
              this.$store.state.buildingId = '123'
            }

            if(this.$route.path == '/content/monitorDetails' && this.$route.query.buildingId){
                //默认选中项3d跳转
                 this.$store.state.menuS = this.$route.query.buildingId;
                 sessionStorage.setItem('menuS',this.$route.query.buildingId)
                 sessionStorage.setItem('menuS2',this.$route.query.buildingId)
                 sessionStorage.setItem('buildingId',this.$route.query.buildingId)
                 sessionStorage.setItem('differentiate',true)
                 
            }else if(this.$route.path == '/content/MonitoringSupervise' && this.$route.query.id){
                 this.$store.state.menuS = this.$route.query.id;
                 sessionStorage.setItem('menuS',this.$route.query.id)
                 sessionStorage.setItem('buildingId',this.$route.query.id)
                 sessionStorage.setItem('differentiate',true); //判断是否可取消状态;
            }
            
        },
        computed: {
            goback(){
                return this.$store.state.btnShow
            },
            navList() {
              // 当点击建筑管理是跳转编辑===此处每次都会执行
              if(sessionStorage.getItem('router')=='constructionManagement'){
                this.$router.push({path:'/content/editBuliting'});
              }
              this.superviseTagging = sessionStorage.getItem('router');
                return this.$store.state.leftMonitorInfo
            },
            reddata(){
                return this.$store.state.reddata
            }, 
            navAddShow() {
                return this.$store.state.navAddShow
            },
            isShowDot(){
              return this.$store.state.listenerIsWarn;
            },
            isShowFirst(){
              return this.$store.state.routerUrl;
            },
            menuS() {
              // 当点击建筑管理是跳转编辑
              if(sessionStorage.getItem('router')=='constructionManagement'){
                //  this.editBuilding()
                this.$router.push({path:'/content/editBuliting'});
              }
              // 判断登陆进来状态menuS的值
              
              if(this.$store.state.menuS&&sessionStorage.getItem('menuS')){
                return this.$store.state.menuS
              }else {
                  if(sessionStorage.getItem("router") == 'MonitoringSupervise'||sessionStorage.getItem("router") == 'analysis'||sessionStorage.getItem("router") == 'report' || sessionStorage.getItem("router") == 'deviceList'){
                    if(this.$store.state.leftMonitorInfo[0]){
                      sessionStorage.setItem('menuS',this.$store.state.leftMonitorInfo[0].id);  // 缓存建筑id
                      this.$store.state.menuS = this.$store.state.leftMonitorInfo[0].id;
                      return this.$store.state.leftMonitorInfo[0].id;
                    }else{
                        return ''
                    }
                  }else{
                    if(this.$store.state.leftMonitorInfo[0].children[0]){
                      return this.$store.state.leftMonitorInfo[0].children[0].id
                    }else{
                        return ''
                    }
                  }
              }
            },
            changeRouterName(){
              return this.$store.state.routerUrlName;
            }
        },
        watch: {
            goback(val){
              this.btnShow = sessionStorage.getItem('btnShow')
            },
            navList(val) {
                let openArray = JSON.parse(sessionStorage.getItem('openID'));  //监听左侧导航展开
                if (openArray != null) {
                    val.map( e => { 
                        openArray.map(i => {
                            if (i == e.id) {
                                e.active = false;
                            }
                        })
                    })
                }
            },
            reddata(val){
                this.redArray = this.$store.state.reddata;
                if(this.redArray.length != 0){
                  this.redShow = true;
                }else{
                    this.redShow = false;
                }
            },
          changeRouterName(val){
              this.collapsed=false;
          },
        },
        updated() {
            this.differentiate = JSON.parse(sessionStorage.getItem('differentiate'));
            if(this.differentiate){
                    if(sessionStorage.getItem("userType") == 0){ //安监云校企标注
                        this.tipInput='搜校企名称'
                    }else{
                        // this.tipInput='搜建筑名称'
                        this.tipInput='搜校企名称'
                    }
            }else {
                if(sessionStorage.getItem("userType") == 0){ //安监云校企标注
                        this.tipInput='搜校企名称'
                    }else{
                        if(sessionStorage.getItem('remark') == 0){
                        // this.tipInput='搜建筑名称'
                            this.tipInput='搜校企名称'
                        }else{
                            this.tipInput='搜索监测点名称、编号'
                        }
                    }
            }
            this.menuS2 = sessionStorage.getItem('menuS2');
            this.showcus = sessionStorage.getItem('showcus') == 1 ? true : false   // 客户是否可以点击1表示可以0不可以
        },
        methods: {
          // 用于判断点击的清楚
            mousearch(event){
                if(event.target.className == "el-input__icon el-icon-circle-close el-input__clear"){
                    this.target = 1;
                }else{
                    this.target = 0
                }
            },
            enter(id) {
                this.editshow = id;
            },
            leave() {
                this.editshow = ''
            },
            listsecher(){
                this.select1 = false;
                this.$nextTick(function () {
                        this.clearableBack();
                })
            },
            handle(id) {
                let _this = this
                _this.navList.map( e => {
                    if(e.id == id) {
                        e.active = !e.active;
                        if (e.active) {
                          if(_this.openID.length>0){
                            let aT = 1;
                            _this.openID.forEach((item,index)=>{
                              if(id == item){
                                aT = 2;
                              }
                            })
                            if(aT==1){
                              _this.openID.push(id);
                              sessionStorage.setItem('openID',JSON.stringify(_this.openID))
                            }
                          }else{

                            _this.openID.push(id);
                            sessionStorage.setItem('openID',JSON.stringify(_this.openID))
                          }
                            
                        }
                    }
                });
                this.$forceUpdate();
            },
            handleChildren(id) {
                let _this = this
                _this.navList.map( e => {
                  e.children.map( item => {
                    if(item.id == id) {
                        item.activeT = !item.activeT;
                        if (item.activeT) {
                          if(_this.openIDChildren.length>0){
                            let aT = 1;
                            _this.openIDChildren.forEach((item,index)=>{
                              if(id == item){
                                aT = 2;
                              }
                            })
                            if(aT==1){
                              _this.openIDChildren.push(id);
                              sessionStorage.setItem('openIDChildren',JSON.stringify(_this.openIDChildren))
                            }
                          }else{

                            _this.openIDChildren.push(id);
                            sessionStorage.setItem('openIDChildren',JSON.stringify(_this.openIDChildren))
                          }
                            
                        }
                    }
                  })
                    // if(e.id == id) {
                    //     e.active = !e.active;
                    //     if (e.active == true) {
                    //         _this.openID.push(id);
                    //         sessionStorage.setItem('openID',JSON.stringify(_this.openID))
                    //     }
                    // }
                });
                this.$forceUpdate();
            },
            
            TipsSure(){ //确认提示
                this.dialogTipsSureVisible = false;
                this.$router.push({path:'/content/BasicData'}); //监测点首页
            },
            getMap(id,idlabel,ids,label,a,b,c) { // 点击楼层事件
                  sessionStorage.setItem('ruleFormOption',{})//重置清除2020.8.4
                let _this = this;
                if(sessionStorage.getItem("router") == 'warningManger'&&c=='middle'&&this.userType==0||sessionStorage.getItem("router") == 'indexExamine'&&c=='middle'&&this.userType==0||sessionStorage.getItem("router") == 'searchWarnIndex'&&c=='middle'&&this.userType==0||sessionStorage.getItem('router') == 'constructionManagement'||sessionStorage.getItem('router') == 'BasicData'&&c=='middle'&&this.userType==0){
                  return;
                }
                // Monitoring
                if(sessionStorage.getItem("router") == 'MonitoringSupervise'){
                  if(b == 'jian'){
                    _this.$router.push({path:'../content/MonitoringSupervise'}); //报警详情
                  }else if(b=='school'){
                      _this.$router.push({path:'../content/Monitoring'}); 
                  }
                }
                _this.$store.state.sum = 0;
                _this.$store.state.menuS = ids;
                _this.$store.state.buildingId = ids; //监听左侧导航变化
                _this.$store.state.analyBuildingId = ids; //监听左侧导航变化

                sessionStorage.setItem('menuS',ids);
                sessionStorage.setItem('customerId',id);  // 缓存客户id
                sessionStorage.setItem('customerName',idlabel); //缓存客户名
                sessionStorage.setItem('buildingId',ids);  // 缓存建筑id
                sessionStorage.setItem('analyBuildingId',ids);  // 缓存建筑id-统计分析专用
                sessionStorage.setItem('Name', label)
                sessionStorage.setItem('analyName', label) // 缓存建筑名或客户名-统计分析专用

                if(sessionStorage.getItem("router") =='analysis'&&c=='middle'&&this.userType==0){
                  sessionStorage.setItem('analyBuildingId','');  // 缓存建筑id
                  _this.$store.state.analyBuildingId = ''; //监听左侧导航变化

                 sessionStorage.setItem('customerId',ids);  // 缓存客户id
                 _this.$store.state.analyCustomerId = ids;
                }
                
                if (sessionStorage.getItem('router') == 'constructionManagement') {   //进入constructionManagement页面的事件
                  return; //增加点击建筑去掉下面执行的
                    sessionStorage.setItem('remark','1')  // 区分客户还是楼层坐标0表示客户坐标
                    if(this.isAuth('common:interface')) {
                        let params = {
                            buildingId: ids,
                        }
                        ajaxFuncJson('/basicData/getBuildingFloor',params).then(res=>{ // 查询楼层列表
                            if(res.data.status == 200) {
                                if (res.data.data.length != '0') {    
                                    sessionStorage.setItem('rightList',true);  // 右侧楼层显示
                                    _this.$store.state.rightList = true
                                    _this.floorListData = res.data.data
                                    _this.floorListData.map(e => {
                                        if (e.floorIndexs == '1') {  // 默认L1层
                                            e.active = true
                                        } else {
                                            e.active = false
                                        }
                                    })
                                    sessionStorage.setItem('floorData',JSON.stringify(_this.floorListData));
                                    _this.$store.state.floorList = JSON.parse(sessionStorage.getItem('floorData'))
                                    if (_this.$store.state.floorList.length > 5) {
                                        if (_this.$store.state.floorList.findIndex( e => e.floorIndex == 1) > 4) {
                                        _this.$store.state.floorListIndexL1 = - (_this.$store.state.floorList.findIndex( e => e.floorIndex == 1) - 4) * 40;
                                        } else {
                                        _this.$store.state.floorListIndexL1 = 0
                                        }
                                    } else if (_this.$store.state.floorList.length == 0){

                                    } else {
                                        _this.$store.state.floorListIndexL1 = 0
                                    } 
                                    res.data.data.map( e => {
                                        if (e.floorIndexs == '1') {
                                            _this.floorid = e.id;
                                            sessionStorage.setItem('floorid',e.id)
                                            sessionStorage.setItem('floorIndex',e.floorIndex)
                                        }
                                    })
                                    let params = {
                                        buildingId: ids,
                                        customerId: id,
                                        floorId: _this.floorid,
                                        remark: '1',
                                        buildingName: label
                                    }
                                    ajaxFuncJson('/basicData/getBuildwithMonitor',params).then(res=>{
                                        sessionStorage.setItem('floor','1'); //点击客户还是楼层0表示客户
                                        _this.floorType = sessionStorage.getItem("floor");
                                        sessionStorage.setItem('pointData',JSON.stringify(res.data.data));
                                        _this.$store.dispatch('getRightPoint',res.data.data);
                                        if (a == '1') {
                                            _this.$router.push({path:'/content/constructionManagement'})
                                        }
                                    });
                                } else {
                                    sessionStorage.setItem('floorData',JSON.stringify(res.data.data));
                                    _this.$store.state.floorList = JSON.parse(sessionStorage.getItem('floorData'))
                                    sessionStorage.setItem('rightList',false);  // 右侧楼层显示
                                    _this.$store.state.rightList = false;
                                    sessionStorage.setItem('floorIndex','')
                                    let params = {
                                        buildingId: ids,
                                        customerId: id,
                                        floorId: '',
                                        remark: '1'
                                    }
                                    ajaxFuncJson('/basicData/getBuildwithMonitor',params).then(res=>{
                                        sessionStorage.setItem('floor','1'); //点击客户还是楼层0表示客户
                                        _this.floorType = sessionStorage.getItem("floor");
                                        sessionStorage.setItem('pointData',JSON.stringify(res.data.data))
                                        _this.$store.dispatch('getRightPoint',res.data.data);
                                        if (a == '1') {
                                            _this.$router.push({path:'/content/constructionManagement'})
                                        }
                                    });
                                }
                            }
                        });
                    }
                }else if(sessionStorage.getItem('router') == 'BasicData'){
                    if(sessionStorage.getItem('complete') == 'false'){
                        _this.dialogTipsSureVisible = true;
                    }else{
                        _this.$router.push({path:'../content/BasicData'}); //监测点首页
                    }
                } else if(sessionStorage.getItem('router')=='warningManger'){
                  _this.$router.push({path:'../content/warningManger'}); //报警详情
                } else if(sessionStorage.getItem('router')=='indexExamine'){
                  _this.$router.push({path:'../content/indexExamine'}); //报警审核
                } else if(sessionStorage.getItem('router')=='searchWarnIndex'){
                  _this.$router.push({path:'../content/searchWarnIndex'}); //综合查询
                } else if(sessionStorage.getItem('router')=='Monitoring'){
                  _this.$router.push({path:'../content/Monitoring'}); //监测详情
                }
            },
            // 点击检测设备
            getmapInfo(e,id,floorId,buildingId,floorIndex) {
                let _this = this;
                if (_this.menuS2 == id) {
                    _this.menuS2 = ''
                    sessionStorage.setItem('menuS2','')
                    if(sessionStorage.getItem("userType") != 0){ //安监云判断
                        _this.$store.state.pointData.Info.map( j => {
                            j.big = false
                        })
                    }
                } else {
                    _this.menuS2 = id;
                    sessionStorage.setItem('menuS2flag',e.buildingId);
                    sessionStorage.setItem('menuS2',id)
                    _this.$store.state.menuS2 = id;
                    if (e.remark == '0') { // 客户
                        if (e.flag) {
                            _this.$store.state.pointData.Info.map( j => {
                                j.big = false
                            })
                        } else {
                            _this.$store.state.pointData.Info.map( j => {
                                if (id == j.id) {
                                    _this.$set(j,'big',true)
                                } else {
                                    _this.$set(j,'big',false)
                                }
                            })
                        }
                    } else {
                        if(sessionStorage.getItem("userType") == 0){ //安监云判断
                        }else{
                           if(sessionStorage.getItem('rightList') == 'false'){//四期判断建筑标记选中（区分点击楼层与设备）
                                let params = {
                                    id: sessionStorage.getItem('customerId'),
                                }
                                // ajaxFuncJson('/building/showBuilding',params).then(res=>{
                                //     res.data.data.Info.map(e => {
                                //         if (id == e.id) {
                                //             e.big = true;
                                //         } else {
                                //             e.big = false;
                                //         }
                                //     })
                                //     sessionStorage.setItem('pointData',JSON.stringify(res.data.data))
                                //     _this.$store.dispatch('getRightPoint',res.data.data)
                                // });
            
                           }else{
                               if (e.flag) {
                                   _this.$store.state.pointData.Info.map( j => {
                                       j.big = false
                                   })
                               } else {
                                   // 获取当前标记点的楼层数据
                                   let params = {
                                       buildingId: buildingId,
                                       customerId: sessionStorage.getItem('customerId'),
                                       floorId: floorId,
                                       remark: '1'
                                   }
                                   ajaxFuncJson('/basicData/getBuildwithMonitor',params).then(res=>{
                                       res.data.data.Info.map(e => {
                                           if (id == e.id) {
                                               e.big = true;
                                           } else {
                                               e.big = false;
                                           }
                                       })
                                       sessionStorage.setItem('pointData',JSON.stringify(res.data.data))
                                       _this.$store.dispatch('getRightPoint',res.data.data)
                                   });
                                   if(_this.isAuth('common:interface')) {
                                       let params1 = {
                                           buildingId: buildingId,
                                       }
                                       ajaxFuncJson('/basicData/getBuildingFloor',params1).then(res=>{
                                          if (res.data.status == 200) {
                                               _this.floorListData = res.data.data;
                                               _this.floorListData.map(e => {
                                               if (e.id == floorId) {  // 默认L1层
                                                       e.active = true
                                                   } else {
                                                       e.active = false
                                                   }
                                               })
                                               sessionStorage.setItem('floorData',JSON.stringify(_this.floorListData));
                                               _this.$store.state.floorList = JSON.parse(sessionStorage.getItem('floorData'))
                                               if (_this.$store.state.floorList.length > 5) {
                                                   if (_this.$store.state.floorList.findIndex( e => e.floorIndex == floorIndex) > 4) {
                                                   _this.$store.state.floorListIndexL1 = - (_this.$store.state.floorList.findIndex( e => e.floorIndex == floorIndex) - 4) * 40;
                                                   } else {
                                                   _this.$store.state.floorListIndexL1 = 0
                                                   }
                                               } else if (_this.$store.state.floorList.length == 0){
       
                                               } else {
                                                   _this.$store.state.floorListIndexL1 = 0
                                               } 
                                           }   
                                       })
                                   }
                               }
                           }
                        }
                    }
                }
                this.menuS2Change = !this.menuS2Change;
                sessionStorage.setItem('menuS2Change',this.menuS2Change); //点击左侧
                this.$store.state.menuS2Change = this.menuS2Change; //监听左侧导航变化
            },
            nothing() {

            }, // 不允许设置点
            editBuilding(obj) {
              if(obj&&this.userType==0){
                sessionStorage.setItem('customerId',obj);  // 缓存客户id
                sessionStorage.setItem('menuS',obj);
                this.$store.state.menuS = obj;
              }
                let from = {
                    buildingName: '',
                    area: '',
                    address: [],
                    onFloor: '',
                    underFloor: '',
                    coverArea: '',
                    detailAddress: '',
                }
                sessionStorage.setItem('editBulitData',JSON.stringify(from));
                this.$store.state.editBulitData = from;
                sessionStorage.setItem('saveBtn',true);
                this.$store.state.saveBtn = true;
                this.$store.state.menuS = sessionStorage.getItem('customerId');
                sessionStorage.setItem('menuS',sessionStorage.getItem('customerId'))
                // this.$router.push({path:'/content/editBuliting'});
                              if(sessionStorage.getItem('router')=='constructionManagement'){
                this.$router.push({path:'/content/editBuliting'});
              }
            },
            checkEdit(id,label,childrenid,childrenlabel) {
                if (this.isAuth('common:interface')) {
                    this.getMap(id,label,childrenid,childrenlabel);

                    //建筑管理页面 return啦getMap方法   选中效果放在这里
                    this.$store.state.sum = 0;
                    this.$store.state.menuS = childrenid;
                    this.$store.state.buildingId = childrenid; //监听左侧导航变化
                    this.$store.state.analyBuildingId = childrenid; //监听左侧导航变化
                    sessionStorage.setItem('menuS',childrenid);
                    sessionStorage.setItem('customerId',id);  // 缓存客户id
                    sessionStorage.setItem('customerName',label); //缓存客户名



                    sessionStorage.setItem('Name', childrenlabel)
                    sessionStorage.setItem('navAddShow',true);
                    this.$store.state.navAddShow = true;
                    sessionStorage.setItem('buildingId',childrenid);
                    this.activeIndex = childrenid;
                    sessionStorage.setItem('activeIndex',childrenid);
                    let params = {
                        buildingId: childrenid,
                    }
                    ajaxFuncJson('/basicData/selectByPrimaryKey',params).then(res=>{
                        if (res.data.status == 200) {
                            if (res.data.data.area == 0) {
                                res.data.data.area = ''
                            }
                            if (res.data.data.coverArea == 0) {
                                res.data.data.coverArea = ''
                            }
                            res.data.data.address = res.data.data.address.split('|');
                            sessionStorage.setItem('editbuiltID',res.data.data.id);    // 缓存编辑建筑id
                            sessionStorage.setItem('saveBtn',false);
                            this.$store.state.saveBtn = false;
                            sessionStorage.setItem('editBulitData',JSON.stringify(res.data.data));
                            this.$store.state.editBulitData = res.data.data;
                            // this.$router.push({path:'/content/editBuliting'});
                                          if(sessionStorage.getItem('router')=='constructionManagement'){
                this.$router.push({path:'/content/editBuliting'});
              }
                        }
                    });
                }
            },
            handleOpen(key, keyPath) { //点击客户
                if(sessionStorage.getItem("router") == 'MonitoringSupervise'){
                  this.$router.push({path:'../content/MonitoringSupervise'}); //报警详情
                }
      
                 if(sessionStorage.getItem('router') == 'constructionManagement') {
                   return;
                 }
                if (sessionStorage.getItem("router") == 'constructionManagement' || sessionStorage.getItem("router") == 'analysis'|| sessionStorage.getItem("router") == 'MonitoringSupervise'|| sessionStorage.getItem("router") == 'report' || sessionStorage.getItem("router") == 'deviceList') {
                    if(sessionStorage.getItem("router") == 'MonitoringSupervise'){
                        this.differentiate = false;
                    }
                    this.$store.state.menuS = key
                    sessionStorage.setItem('menuS',key)
                    this.$store.state.buildingId = key
                    sessionStorage.setItem('buildingId',key)
                } else {
                    this.$store.state.menuS = ''
                    sessionStorage.setItem('menuS','')
                }
                sessionStorage.setItem('customerId',key);  // 缓存客户id
                sessionStorage.setItem('customerName', keyPath); //缓存客户名
                sessionStorage.setItem('Name', keyPath);  // 客户名或者建筑名
                sessionStorage.setItem('analyName', keyPath);  // 缓存客户名或者建筑名-统计分析专用
                sessionStorage.setItem('analyBuildingId', ''); // 缓存客户id-统计分析专用
                this.$store.state.analyBuildingId = sessionStorage.getItem('analyBuildingId');
                this.$store.state.analyCustomerId = key;
            },
            // 根据客户id查询相关总揽图中的检测点
            getPoint() { //四期总览图标记
                if (this.isAuth('common:interface')) {
                    let params = {
                        id: sessionStorage.getItem('customerId'),
                    }
                }
            },
            childrenId(customerId,buildingId){
                let params = {
                    childrenId: customerId,
                    buildingId: buildingId
                }
               sessionStorage.setItem("childrenId",JSON.stringify(params))
               this.$router.push({path:'/content/BasicData'}); //监测点首页
            },
            getBuilding() { // 搜索建筑
               this.$refs.inputRef.$el.children[0].blur();
                if(sessionStorage.getItem("userType") == 0){ //安监云判断
                    let params = {
                        customerId:sessionStorage.getItem('bureaucustomerId'), //6期教育局2020.8.19
                        // customerId:sessionStorage.getItem('customerId1'), //6期教育局2020.8.19
                        buildingName: this.navListName,
                        target: 1,
                    }
                    ajaxFuncJson('/basicData/getCustomerList',params).then(res=>{
                        if (res.data.status == 200) {
                            res.data.data[0].active = false; //12-26X

                            sessionStorage.setItem('leftData',JSON.stringify(res.data.data))
                            this.$store.dispatch('getLeftDataList',JSON.parse(sessionStorage.getItem('leftData')))
                           if(res.data.data == ''|| !res.data.data) {
                                this.select2 = false;
                                return ;
                            } else {
                                this.select2 = true;
                            }
                            if(sessionStorage.getItem('router')=='MonitoringSupervise'){
                              this.getAlarmList()
                            }
                        } else {
                            this.$message.error(res.data.msg)
                        }
                    })
                }else{

                    let params = {
                        buildingName: this.navListName,
                        // flag: 'true',
                        target: "0",
                        // target: sessionStorage.getItem('target'),
                        customerId:sessionStorage.getItem('customerId1')
                    }
                    ajaxFuncJson('/basicData/getBuilding',params).then(res=>{
                        sessionStorage.setItem('leftData',JSON.stringify(res.data.data));
                        this.$store.dispatch('getLeftDataList',res.data.data)
                        // 校企端也增加红点
                        this.getAlarmList();
                        if(res.data.data == '') {
                            this.select2 = false;
                        } else {
                            this.select2 = true;
                        }
                    });
                }
            },
            getAlarmList() {  //监管端报警小红点
              let params = {
                  pageType: 0,
                  customerId:sessionStorage.getItem('customerId1'), //6期教育局2020.8.19
              }
              ajaxFuncJson('/basicData/getAList',params).then(res=>{
                if(res.data.status == 200){
                  let InfoArr = JSON.parse(sessionStorage.getItem('leftData'))
                  
                  if(this.userType!=0){
                    InfoArr.forEach((item,index)=>{
                      if(res.data.data.length>0){
                        item.alarmTrue = 1;
                        item.children.forEach((item1,index)=>{
                          res.data.data.forEach((item2,index)=>{
                            if(item1.id == item2){
                                item1.alarmTrue = 1;
                            }
                          })
                          
                        })
                      }
                    })
                  }else{
                    InfoArr.forEach((item,index)=>{
                      if(res.data.data.length>0){
                        item.alarmTrue = 1;
                        item.children.forEach((item1,index)=>{

                          item1.children.forEach((item2,index2)=>{  


                              res.data.data.forEach((item3,index3)=>{
                                if(item2.id == item3){
                                      item1.alarmTrue = 1;
                                    item2.alarmTrue = 1;
                                }
                              })


                          })

                          
                          
                        })
                      }
                    })

                  }

                  sessionStorage.setItem("leftData", JSON.stringify(InfoArr));
                  this.$store.dispatch("getLeftDataList", InfoArr);
                }
              })
            },
            getCheckPoint (){ // 搜索检测点 
                this.$refs.inputRef.$el.children[0].blur();
                if(sessionStorage.getItem("userType") == 0){ //安监云判断
                       let params = {
                           customerId:sessionStorage.getItem('bureaucustomerId'), //6期教育局2020.8.19
                           buildingName: this.navListName,
                           target: 1,
                       }
                       ajaxFuncJson('/basicData/getCustomerList',params).then(res=>{
                           if (res.data.status == 200) {
                               res.data.data[0].active = false; //12-26X

                               sessionStorage.setItem('leftData',JSON.stringify(res.data.data))
                               this.$store.dispatch('getLeftDataList',JSON.parse(sessionStorage.getItem('leftData')))
                              if(res.data.data == ''|| !res.data.data) {
                                    this.select2 = false;
                                    return ;
                                } else {
                                    this.select2 = true;
                                }
                           } else {
                               this.$message.error(res.data.msg)
                           }
                       })
                 }
                if(sessionStorage.getItem('remark') == 0) { //校企端
                        let params = {
                            buildingName: this.navListName,
                            flag: 'true',
                            target: "1"
                        }
                        ajaxFuncJson('/basicData/getBuilding',params).then(res=>{
                            if (res.data.status == 200) {
                                sessionStorage.setItem('leftData',JSON.stringify(res.data.data))
                                this.$store.dispatch('getLeftDataList',JSON.parse(sessionStorage.getItem('leftData')))
                            } else {
                                this.$message.error(res.data.msg)
                            }
                        })
                } else if(sessionStorage.getItem('remark') == '1'){
                    let params = {
                        customerId: sessionStorage.getItem('customerId'),
                        buildingId: sessionStorage.getItem('buildingId'),
                        remark: '' + sessionStorage.getItem('remark'),
                        monitoringName: this.navListName
                    }
                    ajaxFuncJson('/basicData/getLeftMonitorInfo',params).then(res=>{
                        if (res.data.status == 200) {
                            sessionStorage.setItem('leftData',JSON.stringify(res.data.data))
                            this.$store.dispatch('getLeftDataList',JSON.parse(sessionStorage.getItem('leftData')))
                        } else {
                            this.$message.error(res.data.msg)
                        }
                    })
                }
            },
            testMess() {  // 搜索框隐藏
                 if(this.target == 1){
                  this.navListName = '';
                  this.$refs.inputRef.$el.children[0].focus();
                  this.target = 0
                }else{
                    if(this.navListName == '') {
                        this.select1 = true;
                    } 
                    this.getBuilding();
                }   
            },
            searchMonter(){
                if(this.target == 1){
                  this.navListName = '';
                  this.$refs.inputRef.$el.children[0].focus();
                  this.target = 0
                }else{
                    if(this.navListName == '') {
                      this.select1 = true;
                    }
                    this.getCheckPoint();
                }
            },
            //清除回调
            clearableBack() {
               this.$refs.inputRef.$el.children[0].focus();
                if(this.navListName !=''){
                    if(this.differentiate){
                        this.getBuilding()
                    }else {
                        this.getCheckPoint(); 
                    }
                }
            },
            //折叠导航栏
            leftoggle(){
              //false 展开  true 收起
                this.collapsed = !this.collapsed;
                sessionStorage.setItem('collapsed',this.collapsed);
                sessionStorage.setItem('leftoggle',this.collapsed);
                this.$store.state.leftoggle = this.collapsed; //监听左侧导航变化
            },
            //文字显示...
            changeText(e){
                let ev = e || window.event;
                this.overflowText = $(ev.srcElement).outerWidth(true);
            },
        },
        mounted() {
            let that = this;
            function initFont() {
                that.heightLeft = $(document.body).height() - $('.el-header').outerHeight(true)- $('.search-tit').outerHeight(true);
                that.spanWidth = $('.el-aside').width() - 100;
                that.spanWidthChild = $('.el-aside').width() - 150;
            }initFont();
            $(window).resize(initFont);
        },
    }
</script>
<style scoped lang="scss">
    @import "@/assets/css/mixin.scss";
    .el-aside .is-active {
        color: #198cff !important;
    }
    .sidebar {
        position: relative;
        overflow: auto;
    }
    .sidebar {
        position: relative;
        overflow: auto;
        .tree {
            .menu_select {
                color: #198cff;
            }
            .show {
                display: block;
            }
            .hide {
                display: none;
            }
            .title {
                height: 58px;
                line-height: 58px;
                color: #fff;
                .tip_detailForm{
                    position: absolute;
                    right: -11px;
                    top: 3px;
                    @include wh(6px,6px);
                    background-color: #ec1c00;
                    border-radius: 50%;
                }
                span {
                    position: relative;
                    cursor: pointer;
                }
                i {
                    float: left;
                    @include wh(28px,28px);
                    margin: 15px 0 0 15px;
                    cursor: pointer;
                }
                .icon-up {
                    @include bgImg('../assets/img/up1.png')
                }
                .icon-bottom {
                    @include bgImg('../assets/img/down1.png')
                }
                b {
                    float: right;
                    @include wh(28px,28px);
                    margin-top: 15px;
                    margin-right: 11px;
                    position: relative;
                    cursor: pointer;
                    @include bgImg('../assets/img/u501.png');
                    &:hover {
                        @include bgImg('../assets/img/u502.png');
                    }
                    &:focus {
                        @include bgImg('../assets/img/u503.png');
                    }
                }
            }
            ul li,.section {
                // height: 58px;
                line-height: 58px;
                color: #fff;
                background: #173673;
                margin-bottom: 2px;
                position: relative;
                &:last-child {
                    margin-bottom: 0;
                }
                .section_text {
                    // float: left;
                    margin-left: 50px;
                    @include textOverflow;
                    cursor: pointer;
                    span {
                        position: relative;
                        outline:none;
                    }
                }
                .tip_detailForm{
                    position: absolute;
                    right: -11px;
                    top: 3px;
                    @include wh(6px,6px);
                    background-color: #ec1c00;
                    border-radius: 50%;
                }
                i {
                    float: left;
                    @include wh(28px,28px);
                    margin: 15px 0 0 0px;
                    cursor: pointer;
                }
                .icon-up {
                    @include bgImg('../assets/img/up1.png')
                }
                .icon-bottom {
                    @include bgImg('../assets/img/down1.png')
                }
                .b {
                    float: right;
                    height: 24px;
                    padding: 0 5px;
                    border-radius: 12px;
                    margin-top: 15px;
                    margin-right: 11px;
                    cursor: pointer;
                    background-color: #198cff;
                    color: #fff;
                    text-align: center;
                    line-height: 24px;
                    font-weight: normal;
                }
                .tag {
                    @include bgImg('../assets/img/tag1.png');
                    background-color: transparent !important;
                    width: 24px !important;
                    &:hover {
                        @include bgImg('../assets/img/tag.png');
                    }
                }
                .edit {
                    position: absolute;
                    right: 15px;
                    top: 17px;
                    // float: right;
                    @include wh(24px,24px);
                    // margin-top: 17px;
                    // margin-right: 15px;
                    cursor: pointer;
                    @include bgImg('../assets/img/edit1.png');
                    color: #fff;
                    text-align: center;
                    line-height: 24px;
                    font-weight: normal;
                    &:hover {
                        @include bgImg('../assets/img/edit.png');
                    }
                }
                .editAdd{
                   position: absolute;
                    right: 15px;
                    top: 17px;
                    // float: right;
                    @include wh(28px,28px);
                    // margin-top: 17px;
                    // margin-right: 15px;
                    cursor: pointer;



                    @include bgImg('../assets/img/u501.png');
                    &:hover {
                        @include bgImg('../assets/img/u502.png');
                    }
                    &:focus {
                        @include bgImg('../assets/img/u503.png');
                    }

                    



                }
            }
        }
    }
    .search-tit {
        height: 58px;
        line-height: 58px;
        padding: 0 7px 0 20px;
        h3 {
            float: left;
            color: #e5e5e5;
            font-weight: normal;
            font-size: $fontSizeThree;
        }
        div {
            float: right;
            @include wh(36px,36px);
            margin-top: 11px;
            cursor: pointer;
            &:hover {
                @include borderRadius(50%);
                background-color: #198cff;
            }
        }
        i {
            display: block;
            @include wh(16px,16px);
            margin: 10px 0 0 10px;
            @include bgImg('../assets/img/search1.png');
        }
    }
    .search-btn {
        position: relative;
        @include wh(94%,58px);
        margin: 0 auto;
        @include borderRadius(2px);
        i {
            position: absolute;
            top: 21px;
            left: 10px;
            @include wh(16px,16px);
            @include bgImg('../assets/img/search2.png');
            cursor: pointer;
            z-index: 1;
        }
        .el-input__suffix {
            margin: 16px 4px 0 0;
        }
    }
    .menu-toggle {
        @include wh(40px,40px);
        .icon-outdent,.icon-indent {
            top: 50%;
            @include wh(40px,40px);
            border: 0;
            opacity: 0.5;
            cursor: pointer;
            z-index: 200;
        }
        .icon-outdent {
            position: absolute;
            right: 0;
            @include bgImg('../assets/img/leftsvg.svg');
            @include translates(0,-20px);
            &:hover {
                opacity: 1;
            }
            &:focus {
                opacity: 0.8;
            }
        }
        .icon-indent {
            position: fixed;
            left: 0;
            @include bgImg('../assets/img/rightsvg.svg');
            @include translates(0,10.5px);
            &:hover {
                opacity: 1;
            }
            &:focus {
                opacity: 0.8;
            }
        }
    }
    .no-data {
        margin-top: 27px;
        color: #fff;
        text-align: center;
        font-size: 14px;
    }
    .Divbadge{
      background-color: #ff0000;
      border-radius: 10px;
      color: #FFFFFF;
      display: inline-block;
      font-size: 12px;
      height: 6px;
      line-height: 6px;
      padding: 0 3px;
      text-align: center;
      white-space: nowrap;
      margin-left: 1px;
      position: relative;
      top: -8px;
    }
    .floorLeft{
      position: relative;
    }
    .floorLeftChild{
      height: 58px;
      line-height: 58px;
      color: #fff;
      background: #173673;
      margin-bottom: 2px;
      position: relative;
      overflow: hidden;
    }
    .floorLeftChildL{
      float: left;
      margin-left: 100px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
      
    }
    .tip_detailForm1{
      position: absolute;
      top: 20px;
      margin-left: 3px;
      width: 6px;
      height: 6px;
      background-color: #ec1c00;
      border-radius: 50%
    }
    .groupIcon{
      float: left;
          width: 16px !important;
    height: 16px !important;
    margin: 20px 8px 0 15px !important;
      cursor: pointer;
      @include bgImg('../assets/img/groupIcon.png')
    }
    .margin60{
          margin-left: 60px !important;
    }
    .margin10{
          margin-left: 10px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/LeftNav.vue